import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

// Mirrors the server's SupplierProductStatus (supplierproductstatuses). The ids
// track ProductStatusIds, so 3 is held back for an On Hold that may never exist.
//
// RETIRED is in the enum so the filters below can already exclude it, but it
// stays out of getSupplierProductStatii() until WXTG/cynque-api-server#1709
// seeds it: until then the server has no row for it, so it must not be offered.
export enum SupplierProductStatusIds {
  PENDING = 1,
  ACTIVE = 2,
  RETIRED = 4,
}

export function getSupplierProductStatii(): ISelectItem[] {
  return [
    { id: SupplierProductStatusIds.PENDING, label: 'Pending' },
    { id: SupplierProductStatusIds.ACTIVE, label: 'Active' },
    // { id: SupplierProductStatusIds.RETIRED, label: 'Retired' },
  ]
}

export const getSupplierProductStatusByLabel = getItemByLabelFactory(
  getSupplierProductStatii
)

export const getSupplierProductStatusById = getItemByIdFactory(
  getSupplierProductStatii
)

// A Retired supplier-product stays the record that existing msServices were
// built from, so it is still fetched and rendered; it is only never offered as
// the source of a NEW msService or a new kit nesting.
//
// Takes any status-bearing row: the select lists hand it IEntityDataItem, which
// declares no `status`, so the index signature avoids a weak-type mismatch.
export function isRetiredSupplierProduct(supplierProduct: {
  status?: ISelectItem | null
  [propName: string]: unknown
}): boolean {
  return supplierProduct?.status?.id === SupplierProductStatusIds.RETIRED
}
